// Restaurant data - Real Thai restaurants with EatJourney features
export const RESTAURANTS = [
  {
    id: 1,
    name: "ร้านเจ๊ไฝ (Jae Fai)",
    category: "Street Food",
    badges: ["michelin", "shell_chuan_chim"],
    dietary: [],
    coordinates: [13.7523, 100.5108],
    googleMapsUrl: "https://www.google.com/maps/place/Raan+Jay+Fai",
    sourceUrl: "https://shellshuanshim.com/",
    images: ["https://images.unsplash.com/photo-1559314809-0d155014e29e?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80"],
    reviews: {
      google: 4.4,
      facebook: 4.8,
      wongnai: 4.0
    },
    influencerReviews: [
      {
        id: "v1",
        platform: "youtube",
        thumbnail: "https://img.youtube.com/vi/1ZgD3j2y4y8/maxresdefault.jpg",
        url: "https://www.youtube.com/watch?v=1ZgD3j2y4y8",
        title: "Mark Wiens - Eating at Jae Fai",
        timestamp: "5m 30s"
      },
      {
        id: "v2",
        platform: "tiktok",
        thumbnail: "https://images.unsplash.com/photo-1611162617474-5b21e879e113?ixlib=rb-1.2.1&auto=format&fit=crop&w=400&q=80",
        url: "#",
        title: "@FoodieBKK Reviews",
        timestamp: "0:45"
      }
    ],
    aiAnalysis: {
      pros: ["Crab Omelette is legendary", "Open kitchen experience", "Michelin Star quality"],
      cons: ["Extremely long wait", "Expensive for street food", "No reservations"],
      credibilityScore: 95,
      trend: [60, 75, 85, 90, 95, 92]
    },
    queueData: {
      bestTime: "8:30 AM (Before opening)",
      currentWait: 180,
      history: [10, 30, 120, 180, 240, 150, 60]
    },
    dishes: [
      { name: "Crab Omelette", price: 1000, isSignature: true, image: "https://images.unsplash.com/photo-1599020792689-9fdeefad48cd?ixlib=rb-1.2.1&auto=format&fit=crop&w=400&q=80" },
      { name: "Drunken Noodles", price: 500, isSignature: false, image: "https://images.unsplash.com/photo-1552611052-33e04de081de?ixlib=rb-1.2.1&auto=format&fit=crop&w=400&q=80" }
    ]
  },
  {
    id: 2,
    name: "ทิพย์สมัย ผัดไทยประตูผี (Thip Samai)",
    category: "Pad Thai",
    badges: ["michelin", "shell_chuan_chim"],
    dietary: [],
    coordinates: [13.7528, 100.5048],
    googleMapsUrl: "https://www.google.com/maps/place/Thip+Samai",
    sourceUrl: "https://shellshuanshim.com/",
    images: ["https://images.unsplash.com/photo-1559314809-0d155014e29e?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80"],
    reviews: { google: 4.2, facebook: 4.5, wongnai: 3.8 },
    influencerReviews: [],
    aiAnalysis: {
      pros: ["Iconic Pad Thai", "Fast service", "Original recipe"],
      cons: ["Sweet taste profile", "Crowded with tourists", "Long queue at dinner"],
      credibilityScore: 88,
      trend: [70, 75, 80, 85, 88, 85]
    },
    queueData: { bestTime: "5:00 PM (Early dinner)", currentWait: 45, history: [0, 20, 45, 60, 90, 30] },
    dishes: [
      { name: "Superb Pad Thai", price: 120, isSignature: true, image: null },
      { name: "Orange Juice", price: 150, isSignature: true, image: null }
    ]
  },
  {
    id: 3,
    name: "วัฒนาพานิช (Wattana Panich)",
    category: "Beef Noodle",
    badges: ["michelin", "shell_chuan_chim"],
    dietary: [],
    coordinates: [13.7392, 100.5294],
    googleMapsUrl: "https://www.google.com/maps/place/Wattana+Panich",
    sourceUrl: "https://shellshuanshim.com/",
    images: [],
    reviews: { google: 4.5, facebook: 4.7, wongnai: 4.2 },
    influencerReviews: [],
    aiAnalysis: {
      pros: ["Rich broth stewed for 50 years", "Tender beef", "Authentic vibe"],
      cons: ["Small portion", "Hot environment", "Limited seating"],
      credibilityScore: 92,
      trend: [80, 82, 85, 88, 90, 92]
    },
    queueData: { bestTime: "10:00 AM", currentWait: 15, history: [10, 30, 45, 20, 10, 5] },
    dishes: [{ name: "Beef Noodle Soup", price: 100, isSignature: true, image: null }]
  },
  {
    id: 4,
    name: "Broccoli Revolution",
    category: "Vegan",
    badges: [],
    dietary: ["vegan", "glutenFree"],
    coordinates: [13.7400, 100.5400],
    googleMapsUrl: "https://www.google.com/maps/place/Broccoli+Revolution+Bangkok",
    images: [],
    reviews: { google: 4.3, facebook: 4.4, wongnai: 4.0 },
    influencerReviews: [],
    aiAnalysis: {
      pros: ["Health-conscious", "Modern atmosphere", "Creative menu"],
      cons: ["Pricey", "Small portions", "Service can be slow"],
      credibilityScore: 85,
      trend: [70, 75, 78, 80, 82, 85]
    },
    queueData: { bestTime: "2:00 PM", currentWait: 0, history: [0, 10, 20, 15, 5, 0] },
    dishes: [{ name: "Quinoa Burger", price: 250, isSignature: true, image: null }]
  },
  {
    id: 5,
    name: "ลิ้มเหล่าโหงว (Lim Lao Ngow)",
    category: "Noodles",
    badges: ["shell_chuan_chim", "michelin"],
    dietary: [],
    coordinates: [13.7462, 100.5348],
    googleMapsUrl: "https://www.google.com/maps?q=Lim+Lao+Ngow+Bangkok",
    sourceUrl: "https://shellshuanshim.com/",
    images: ["https://images.unsplash.com/photo-1569058242253-92a9c755a0ec?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80"],
    reviews: { google: 4.3, facebook: 4.5, wongnai: 4.1 },
    influencerReviews: [],
    aiAnalysis: {
      pros: ["Bouncey fishballs", "Historical recipe", "Convenient location"],
      cons: ["Small portions", "Pricey for noodles"],
      credibilityScore: 90,
      trend: [75, 80, 82, 85, 88, 90]
    },
    queueData: { bestTime: "11:00 AM", currentWait: 15, history: [10, 30, 45, 20, 15, 10] },
    dishes: [{ name: "Fishball Noodles", price: 80, isSignature: true, image: null }]
  },
  {
    id: 6,
    name: "The Foodie by Kannicha",
    category: "Thai",
    badges: ["shell_chuan_chim"],
    dietary: [],
    coordinates: [13.7968, 100.5531],
    googleMapsUrl: "https://www.google.com/maps?q=The+Foodie+by+Kannicha",
    sourceUrl: "https://www.shellshuanshim.com/en/restaurant/the-foodie-by-kannicha",
    images: [],
    reviews: { google: 4.4, facebook: 4.6, wongnai: 4.2 },
    influencerReviews: [],
    aiAnalysis: {
      pros: ["Authentic taste", "Relaxing atmosphere", "Good for families"],
      cons: ["Far from city center", "Early closing"],
      credibilityScore: 85,
      trend: [70, 75, 78, 80, 82, 85]
    },
    queueData: { bestTime: "11:30 AM", currentWait: 10, history: [5, 20, 30, 20, 10, 5] },
    dishes: [{ name: "Khao Khluk Kapi", price: 150, isSignature: true, image: null }]
  },
  {
    id: 7,
    name: "เป็นหนึ่งสนามหลวง (Pennueng Sanam Luang)",
    category: "Thai",
    badges: ["perp_pitsadarn"],
    dietary: [],
    coordinates: [13.9115, 100.5500],
    googleMapsUrl: "https://www.google.com/maps?q=Muang+Thong+Thani",
    sourceUrl: "https://www.facebook.com/PeibPhisdar",
    images: [],
    reviews: { google: 4.0, facebook: 4.2, wongnai: 3.8 },
    influencerReviews: [],
    aiAnalysis: {
      pros: ["Original recipe from Mae Choice", "Variety of menu", "Parking available"],
      cons: ["Crowded during events", "Traffic in area"],
      credibilityScore: 82,
      trend: [60, 65, 70, 75, 80, 82]
    },
    queueData: { bestTime: "1:00 PM", currentWait: 10, history: [10, 20, 30, 20, 10, 5] },
    dishes: [{ name: "Stewed Beef", price: 120, isSignature: true, image: null }]
  },
  {
    id: 8,
    name: "ร้านเปีย เปิบพิสดาร (Pia Perp Pitsadarn)",
    category: "Thai",
    badges: ["perp_pitsadarn"],
    dietary: [],
    coordinates: [13.7890, 100.6050],
    googleMapsUrl: "https://www.google.com/maps?q=Lat+Phrao+64",
    sourceUrl: "https://www.facebook.com/PeibPhisdar",
    images: [],
    reviews: { google: 4.2, facebook: 4.5, wongnai: 4.0 },
    influencerReviews: [],
    aiAnalysis: {
      pros: ["Local favorite", "Friendly service", "Reasonable prices"],
      cons: ["Hard to find parking", "Small shop"],
      credibilityScore: 80,
      trend: [65, 70, 72, 75, 78, 80]
    },
    queueData: { bestTime: "2:00 PM", currentWait: 5, history: [5, 15, 25, 15, 5, 0] },
    dishes: [{ name: "Spicy Stir-fry", price: 100, isSignature: true, image: null }]
  },
  // ========== เชลล์ชวนชิม 2025 - หมวดอาหารไทยต้นตำรับ ==========
  {
    id: 9,
    name: "คุณฉุยกะเพราโบราณ (สาขาบรรทัดทอง)",
    category: "Thai",
    badges: ["shell_chuan_chim"],
    dietary: [],
    coordinates: [13.7467, 100.5317],
    googleMapsUrl: "https://www.google.com/maps/place/คุณฉุยกะเพราโบราณ",
    sourceUrl: "https://shellshuanshim.com/",
    images: [],
    reviews: { google: 4.5, facebook: 4.6, wongnai: 4.3 },
    influencerReviews: [],
    aiAnalysis: {
      pros: ["Best Krapao in Thailand 2024-2025", "4 types of chili", "High quality ingredients"],
      cons: ["Long queue during lunch", "Limited seating"],
      credibilityScore: 92,
      trend: [80, 85, 88, 90, 91, 92]
    },
    queueData: { bestTime: "11:00 AM", currentWait: 20, history: [10, 20, 40, 30, 15, 10] },
    dishes: [
      { name: "ผัดกะเพราหมูสับผัดพริกแห้ง", price: 95, isSignature: true, image: null },
      { name: "กะเพราหมูกรอบไข่ดาว", price: 120, isSignature: false, image: null }
    ]
  },
  {
    id: 10,
    name: "กะเพราสาวโคราช (สาขา Central World)",
    category: "Thai",
    badges: ["shell_chuan_chim"],
    dietary: [],
    coordinates: [13.7467, 100.5394],
    googleMapsUrl: "https://www.google.com/maps/place/กะเพราสาวโคราช+Central+World",
    sourceUrl: "https://shellshuanshim.com/",
    images: [],
    reviews: { google: 4.3, facebook: 4.4, wongnai: 4.1 },
    influencerReviews: [],
    aiAnalysis: {
      pros: ["Original Korat recipe", "Spicy and flavorful", "Mall convenience"],
      cons: ["Can be crowded", "Mall parking fee"],
      credibilityScore: 85,
      trend: [70, 75, 78, 82, 84, 85]
    },
    queueData: { bestTime: "11:30 AM", currentWait: 15, history: [5, 15, 30, 20, 10, 5] },
    dishes: [
      { name: "กะเพราหมูสับ", price: 89, isSignature: true, image: null },
      { name: "กะเพราเนื้อ", price: 99, isSignature: false, image: null }
    ]
  },
  {
    id: 11,
    name: "ครัวยายเปล่ง",
    category: "Thai",
    badges: ["shell_chuan_chim"],
    dietary: [],
    coordinates: [13.7933, 100.4189],
    googleMapsUrl: "https://maps.app.goo.gl/9wf97HwRdptJYp3V6",
    sourceUrl: "https://shellshuanshim.com/",
    images: [],
    reviews: { google: 4.4, facebook: 4.6, wongnai: 4.2 },
    influencerReviews: [],
    aiAnalysis: {
      pros: ["30+ years old recipe", "Riverside atmosphere", "Authentic Thai taste"],
      cons: ["No reservation", "Deep in soi", "Closed Monday"],
      credibilityScore: 88,
      trend: [75, 78, 82, 85, 87, 88]
    },
    queueData: { bestTime: "11:30 AM", currentWait: 30, history: [15, 30, 60, 45, 20, 10] },
    dishes: [
      { name: "ขาหมูทอด", price: 320, isSignature: true, image: null },
      { name: "ปลาช่อนโฮกฮือ", price: 280, isSignature: true, image: null },
      { name: "ขาหมูหมั่นโถว", price: 250, isSignature: false, image: null }
    ]
  },
  {
    id: 12,
    name: "ครัวถึงเจริญ19",
    category: "Thai",
    badges: ["shell_chuan_chim"],
    dietary: [],
    coordinates: [13.7600, 100.5100],
    googleMapsUrl: "https://www.google.com/maps/place/ครัวถึงเจริญ19",
    sourceUrl: "https://shellshuanshim.com/",
    images: [],
    reviews: { google: 4.2, facebook: 4.3, wongnai: 4.0 },
    influencerReviews: [],
    aiAnalysis: {
      pros: ["Traditional Thai recipe", "Family-run business", "Reasonable prices"],
      cons: ["Limited parking", "Small shop"],
      credibilityScore: 82,
      trend: [68, 72, 76, 79, 81, 82]
    },
    queueData: { bestTime: "12:00 PM", currentWait: 15, history: [10, 20, 35, 25, 15, 5] },
    dishes: [{ name: "Thai Curry", price: 120, isSignature: true, image: null }]
  },
  // ========== เชลล์ชวนชิม 2025 - หมวดอาหารจีน ==========
  {
    id: 13,
    name: "หมูหยองโชคดี เบ้ไฮ้ลิ้ม (สาขาวงเวียน 22)",
    category: "Chinese",
    badges: ["shell_chuan_chim"],
    dietary: [],
    coordinates: [13.7517, 100.5033],
    googleMapsUrl: "https://www.google.com/maps/place/หมูหยองโชคดี+เบ้ไฮ้ลิ้ม",
    sourceUrl: "https://shellshuanshim.com/",
    images: [],
    reviews: { google: 4.5, facebook: 4.6, wongnai: 4.3 },
    influencerReviews: [],
    aiAnalysis: {
      pros: ["70+ years history (since 1951)", "Original recipe", "Crispy pork belly"],
      cons: ["Busy area", "Limited seating"],
      credibilityScore: 90,
      trend: [80, 82, 85, 87, 89, 90]
    },
    queueData: { bestTime: "9:00 AM", currentWait: 20, history: [10, 25, 40, 30, 15, 10] },
    dishes: [
      { name: "หมูหยอง", price: 80, isSignature: true, image: null },
      { name: "เบ้ไฮ้ลิ้ม", price: 100, isSignature: true, image: null }
    ]
  },
  {
    id: 14,
    name: "ภัตตาคารเล่งหงษ์",
    category: "Chinese",
    badges: ["shell_chuan_chim"],
    dietary: [],
    coordinates: [13.7300, 100.5200],
    googleMapsUrl: "https://www.google.com/maps/place/ภัตตาคารเล่งหงษ์",
    sourceUrl: "https://shellshuanshim.com/",
    images: [],
    reviews: { google: 4.3, facebook: 4.4, wongnai: 4.1 },
    influencerReviews: [],
    aiAnalysis: {
      pros: ["Classic Chinese cuisine", "Established reputation", "Quality ingredients"],
      cons: ["Higher price point", "Reservation recommended"],
      credibilityScore: 86,
      trend: [72, 76, 80, 83, 85, 86]
    },
    queueData: { bestTime: "6:00 PM", currentWait: 30, history: [15, 30, 50, 45, 25, 15] },
    dishes: [{ name: "Roasted Duck", price: 400, isSignature: true, image: null }]
  },
  {
    id: 15,
    name: "เชี่ยวชาญพานิช (ข้าวต้มเทเวศร์)",
    category: "Chinese",
    badges: ["shell_chuan_chim"],
    dietary: [],
    coordinates: [13.7833, 100.5167],
    googleMapsUrl: "https://www.google.com/maps/place/เชี่ยวชาญพานิช+ข้าวต้มเทเวศร์",
    sourceUrl: "https://shellshuanshim.com/",
    images: [],
    reviews: { google: 4.4, facebook: 4.5, wongnai: 4.2 },
    influencerReviews: [],
    aiAnalysis: {
      pros: ["Famous rice soup", "Late night dining", "Variety of toppings"],
      cons: ["Busy late night", "Street parking only"],
      credibilityScore: 84,
      trend: [70, 74, 78, 81, 83, 84]
    },
    queueData: { bestTime: "10:00 PM", currentWait: 15, history: [10, 20, 30, 25, 15, 10] },
    dishes: [
      { name: "ข้าวต้มปลา", price: 80, isSignature: true, image: null },
      { name: "ข้าวต้มหมู", price: 70, isSignature: false, image: null }
    ]
  },
  // ========== เปิบพิสดาร ==========
  {
    id: 16,
    name: "แม่ช้อยดอยหลวง",
    category: "Thai",
    badges: ["perp_pitsadarn"],
    dietary: [],
    coordinates: [13.8600, 100.5200],
    googleMapsUrl: "https://maps.app.goo.gl/VvtVGzhkcYiKTSVD9",
    sourceUrl: "https://www.facebook.com/PeibPhisdar",
    images: [],
    reviews: { google: 4.5, facebook: 4.7, wongnai: 4.3 },
    influencerReviews: [],
    aiAnalysis: {
      pros: ["Original recipe by Mae Choi Nang Ram", "Northern Thai specialties", "Unique menu items"],
      cons: ["Far from city center", "Reservation recommended"],
      credibilityScore: 92,
      trend: [80, 84, 87, 89, 91, 92]
    },
    queueData: { bestTime: "12:00 PM", currentWait: 20, history: [10, 25, 40, 30, 15, 10] },
    dishes: [
      { name: "มัสมั่นเนื้อ", price: 350, isSignature: true, image: null },
      { name: "แกงฮังเล", price: 320, isSignature: true, image: null },
      { name: "ซี่โครงอ่อนสับผัดใบยี่หร่า", price: 280, isSignature: false, image: null }
    ]
  },
  {
    id: 17,
    name: "เจ๊น้อยข้าวมันไก่ (ปากช่อง)",
    category: "Thai",
    badges: ["perp_pitsadarn"],
    dietary: [],
    coordinates: [14.9800, 102.1000],
    googleMapsUrl: "https://www.google.com/maps/place/เจ๊น้อยข้าวมันไก่+ปากช่อง",
    sourceUrl: "https://www.facebook.com/PeibPhisdar",
    images: [],
    reviews: { google: 4.6, facebook: 4.7, wongnai: 4.4 },
    influencerReviews: [],
    aiAnalysis: {
      pros: ["50+ years heritage", "Perfect chicken rice", "Breakfast destination"],
      cons: ["Early sell out", "Limited seating"],
      credibilityScore: 88,
      trend: [75, 79, 83, 85, 87, 88]
    },
    queueData: { bestTime: "7:00 AM", currentWait: 10, history: [5, 15, 25, 20, 10, 5] },
    dishes: [
      { name: "ข้าวมันไก่", price: 60, isSignature: true, image: null },
      { name: "ไก่ทอด", price: 80, isSignature: false, image: null }
    ]
  },
  // ========== เชลล์ชวนชิม 2025 - หมวดนานาชาติ/ฟิวชัน ==========
  {
    id: 18,
    name: "Baan Biryani",
    category: "Indian",
    badges: ["shell_chuan_chim"],
    dietary: ["halal"],
    coordinates: [13.7400, 100.5300],
    googleMapsUrl: "https://www.google.com/maps/place/Baan+Biryani+Bangkok",
    sourceUrl: "https://shellshuanshim.com/",
    images: [],
    reviews: { google: 4.5, facebook: 4.6, wongnai: 4.3 },
    influencerReviews: [],
    aiAnalysis: {
      pros: ["Authentic Indian cuisine", "Halal certified", "Rich flavors"],
      cons: ["Spicy for some", "Pricey"],
      credibilityScore: 86,
      trend: [72, 76, 80, 83, 85, 86]
    },
    queueData: { bestTime: "12:00 PM", currentWait: 15, history: [10, 20, 30, 25, 15, 10] },
    dishes: [
      { name: "Biryani", price: 250, isSignature: true, image: null },
      { name: "Butter Chicken", price: 280, isSignature: false, image: null }
    ]
  },
  {
    id: 19,
    name: "Copine",
    category: "Fusion",
    badges: ["shell_chuan_chim"],
    dietary: [],
    coordinates: [13.7420, 100.5450],
    googleMapsUrl: "https://www.google.com/maps/place/Copine+Bangkok",
    sourceUrl: "https://shellshuanshim.com/",
    images: [],
    reviews: { google: 4.6, facebook: 4.7, wongnai: 4.4 },
    influencerReviews: [],
    aiAnalysis: {
      pros: ["Modern fusion cuisine", "Creative menu", "Great ambiance"],
      cons: ["Expensive", "Reservation required"],
      credibilityScore: 88,
      trend: [75, 79, 83, 85, 87, 88]
    },
    queueData: { bestTime: "7:00 PM", currentWait: 0, history: [0, 10, 20, 15, 5, 0] },
    dishes: [{ name: "Tasting Menu", price: 1500, isSignature: true, image: null }]
  },
  {
    id: 20,
    name: "Man Hin by Chef Man",
    category: "Chinese",
    badges: ["shell_chuan_chim"],
    dietary: [],
    coordinates: [13.7450, 100.5400],
    googleMapsUrl: "https://www.google.com/maps/place/Man+Hin+by+Chef+Man",
    sourceUrl: "https://shellshuanshim.com/",
    images: [],
    reviews: { google: 4.5, facebook: 4.6, wongnai: 4.3 },
    influencerReviews: [],
    aiAnalysis: {
      pros: ["Celebrity chef", "Premium Chinese cuisine", "Elegant setting"],
      cons: ["Very expensive", "Dress code"],
      credibilityScore: 90,
      trend: [80, 83, 86, 88, 89, 90]
    },
    queueData: { bestTime: "7:00 PM", currentWait: 0, history: [0, 5, 15, 10, 5, 0] },
    dishes: [{ name: "Peking Duck", price: 2000, isSignature: true, image: null }]
  },
  {
    id: 21,
    name: "Yakiniku Oniku to Gohan",
    category: "Japanese",
    badges: ["shell_chuan_chim"],
    dietary: [],
    coordinates: [13.7410, 100.5380],
    googleMapsUrl: "https://www.google.com/maps/place/Yakiniku+Oniku+to+Gohan",
    sourceUrl: "https://shellshuanshim.com/",
    images: [],
    reviews: { google: 4.7, facebook: 4.7, wongnai: 4.5 },
    influencerReviews: [],
    aiAnalysis: {
      pros: ["Premium Japanese beef", "Authentic yakiniku", "Excellent service"],
      cons: ["Very expensive", "Hard to book"],
      credibilityScore: 92,
      trend: [82, 85, 88, 90, 91, 92]
    },
    queueData: { bestTime: "6:00 PM", currentWait: 0, history: [0, 5, 10, 5, 0, 0] },
    dishes: [{ name: "Wagyu Set", price: 2500, isSignature: true, image: null }]
  },
  {
    id: 22,
    name: "LONGTAHN (ลองทาน)",
    category: "Fusion",
    badges: ["shell_chuan_chim"],
    dietary: [],
    coordinates: [13.7380, 100.5350],
    googleMapsUrl: "https://www.google.com/maps/place/LONGTAHN+Bangkok",
    sourceUrl: "https://shellshuanshim.com/",
    images: [],
    reviews: { google: 4.4, facebook: 4.5, wongnai: 4.2 },
    influencerReviews: [],
    aiAnalysis: {
      pros: ["Thai-fusion concept", "Creative dishes", "Good value"],
      cons: ["Can be noisy", "Limited parking"],
      credibilityScore: 84,
      trend: [70, 74, 78, 81, 83, 84]
    },
    queueData: { bestTime: "6:30 PM", currentWait: 20, history: [10, 25, 40, 30, 15, 10] },
    dishes: [{ name: "Fusion Pad Thai", price: 180, isSignature: true, image: null }]
  },
  {
    id: 23,
    name: "หอฝัน",
    category: "International",
    badges: ["shell_chuan_chim"],
    dietary: [],
    coordinates: [13.7360, 100.5320],
    googleMapsUrl: "https://www.google.com/maps/place/หอฝัน",
    sourceUrl: "https://shellshuanshim.com/",
    images: [],
    reviews: { google: 4.5, facebook: 4.6, wongnai: 4.3 },
    influencerReviews: [],
    aiAnalysis: {
      pros: ["Rooftop dining", "City views", "International menu"],
      cons: ["Weather dependent", "Expensive"],
      credibilityScore: 86,
      trend: [72, 76, 80, 83, 85, 86]
    },
    queueData: { bestTime: "6:00 PM", currentWait: 0, history: [0, 10, 20, 15, 5, 0] },
    dishes: [{ name: "Signature Steak", price: 800, isSignature: true, image: null }]
  },
  // ========== เปิบพิสดาร (เพิ่มเติม) ==========
  {
    id: 24,
    name: "โค้วจั้วฮวดขาหมูเจ้าเก่า (วังบูรพา)",
    category: "Chinese",
    badges: ["perp_pitsadarn"],
    dietary: [],
    coordinates: [13.7520, 100.4970],
    googleMapsUrl: "https://www.google.com/maps/place/โค้วจั้วฮวดขาหมูเจ้าเก่า",
    sourceUrl: "https://www.facebook.com/PeibPhisdar",
    images: [],
    reviews: { google: 4.4, facebook: 4.5, wongnai: 4.2 },
    influencerReviews: [],
    aiAnalysis: {
      pros: ["50-60 years history", "Legendary pork knuckle", "Rich flavors"],
      cons: ["Old area", "Limited seating"],
      credibilityScore: 88,
      trend: [76, 80, 83, 85, 87, 88]
    },
    queueData: { bestTime: "11:00 AM", currentWait: 15, history: [10, 20, 30, 25, 15, 10] },
    dishes: [
      { name: "ขาหมูตุ๋น", price: 100, isSignature: true, image: null },
      { name: "ขาหมูทอด", price: 120, isSignature: false, image: null }
    ]
  },
  {
    id: 25,
    name: "ยุ้ยเผือกทอด เสาชิงช้า",
    category: "Thai",
    badges: ["perp_pitsadarn"],
    dietary: [],
    coordinates: [13.7540, 100.4950],
    googleMapsUrl: "https://www.google.com/maps/place/ยุ้ยเผือกทอด+เสาชิงช้า",
    sourceUrl: "https://www.facebook.com/PeibPhisdar",
    images: [],
    reviews: { google: 4.3, facebook: 4.4, wongnai: 4.1 },
    influencerReviews: [],
    aiAnalysis: {
      pros: ["Crispy taro", "Old Bangkok location", "Traditional recipe"],
      cons: ["Street parking", "Hot environment"],
      credibilityScore: 82,
      trend: [68, 72, 76, 79, 81, 82]
    },
    queueData: { bestTime: "2:00 PM", currentWait: 10, history: [5, 15, 25, 20, 10, 5] },
    dishes: [{ name: "เผือกทอด", price: 50, isSignature: true, image: null }]
  },
  {
    id: 26,
    name: "จุ้งบริการ1 (เฮียคุง) อยุธยา",
    category: "Thai",
    badges: ["perp_pitsadarn"],
    dietary: [],
    coordinates: [14.3692, 100.5876],
    googleMapsUrl: "https://www.google.com/maps/place/จุ้งบริการ1+อยุธยา",
    sourceUrl: "https://www.facebook.com/PeibPhisdar",
    images: [],
    reviews: { google: 4.4, facebook: 4.5, wongnai: 4.2 },
    influencerReviews: [],
    aiAnalysis: {
      pros: ["Fresh river prawns", "Riverside dining", "Authentic taste"],
      cons: ["Far from Bangkok", "Weekend crowds"],
      credibilityScore: 85,
      trend: [71, 75, 79, 82, 84, 85]
    },
    queueData: { bestTime: "12:00 PM", currentWait: 30, history: [15, 30, 50, 45, 25, 15] },
    dishes: [
      { name: "กุ้งแม่น้ำเผา", price: 500, isSignature: true, image: null },
      { name: "ทอดมันปลากราย", price: 120, isSignature: false, image: null }
    ]
  },
  {
    id: 27,
    name: "กุ้งอบภูเขาไฟ (นครปฐม)",
    category: "Thai",
    badges: ["perp_pitsadarn"],
    dietary: [],
    coordinates: [13.8200, 100.0400],
    googleMapsUrl: "https://www.google.com/maps/place/กุ้งอบภูเขาไฟ+นครปฐม",
    sourceUrl: "https://www.facebook.com/PeibPhisdar",
    images: [],
    reviews: { google: 4.5, facebook: 4.6, wongnai: 4.3 },
    influencerReviews: [],
    aiAnalysis: {
      pros: ["Fire mountain prawns", "Unique cooking method", "Fresh ingredients"],
      cons: ["Reservation needed", "Far from city"],
      credibilityScore: 86,
      trend: [72, 76, 80, 83, 85, 86]
    },
    queueData: { bestTime: "6:00 PM", currentWait: 45, history: [20, 40, 60, 50, 30, 20] },
    dishes: [
      { name: "กุ้งอบภูเขาไฟ", price: 450, isSignature: true, image: null },
      { name: "แกงส้มกุ้งชะอมไข่", price: 180, isSignature: false, image: null }
    ]
  },
  // ========== เชลล์ชวนชิม 2025 - หมวดก๋วยเตี๋ยว/ร้านเส้น ==========
  {
    id: 28,
    name: "ก๋วยเตี๋ยวเรืออยุธยาเจ๊จุ๋ม",
    category: "Noodles",
    badges: ["shell_chuan_chim"],
    dietary: [],
    coordinates: [14.3692, 100.5876],
    googleMapsUrl: "https://www.google.com/maps/place/ก๋วยเตี๋ยวเรืออยุธยาเจ๊จุ๋ม",
    sourceUrl: "https://shellshuanshim.com/",
    images: [],
    reviews: { google: 4.4, facebook: 4.5, wongnai: 4.2 },
    influencerReviews: [],
    aiAnalysis: {
      pros: ["Authentic Ayutthaya boat noodles", "Rich broth", "Historic recipe"],
      cons: ["Far from Bangkok", "Weekend crowds"],
      credibilityScore: 88,
      trend: [76, 80, 83, 85, 87, 88]
    },
    queueData: { bestTime: "11:00 AM", currentWait: 20, history: [10, 25, 40, 30, 15, 10] },
    dishes: [{ name: "ก๋วยเตี๋ยวเรือ", price: 50, isSignature: true, image: null }]
  },
  {
    id: 29,
    name: "ก๋วยเตี๋ยวเรือลุงอู๊ด",
    category: "Noodles",
    badges: ["shell_chuan_chim"],
    dietary: [],
    coordinates: [14.3700, 100.5880],
    googleMapsUrl: "https://www.google.com/maps/place/ก๋วยเตี๋ยวเรือลุงอู๊ด",
    sourceUrl: "https://shellshuanshim.com/",
    images: [],
    reviews: { google: 4.3, facebook: 4.4, wongnai: 4.1 },
    influencerReviews: [],
    aiAnalysis: {
      pros: ["Original boat noodle recipe", "Strong flavors", "Local favorite"],
      cons: ["Small shop", "Limited parking"],
      credibilityScore: 86,
      trend: [72, 76, 80, 83, 85, 86]
    },
    queueData: { bestTime: "11:30 AM", currentWait: 15, history: [10, 20, 35, 25, 15, 10] },
    dishes: [{ name: "ก๋วยเตี๋ยวเรือ", price: 50, isSignature: true, image: null }]
  },
  {
    id: 30,
    name: "ร้านก๋วยเตี๋ยวไก่ฉีกเข้ากรุง",
    category: "Noodles",
    badges: ["shell_chuan_chim"],
    dietary: [],
    coordinates: [13.7500, 100.5200],
    googleMapsUrl: "https://www.google.com/maps/place/ก๋วยเตี๋ยวไก่ฉีกเข้ากรุง",
    sourceUrl: "https://shellshuanshim.com/",
    images: [],
    reviews: { google: 4.4, facebook: 4.5, wongnai: 4.2 },
    influencerReviews: [],
    aiAnalysis: {
      pros: ["Hand-shredded chicken", "Clear broth", "City location"],
      cons: ["Busy lunch hours", "Street parking"],
      credibilityScore: 84,
      trend: [70, 74, 78, 81, 83, 84]
    },
    queueData: { bestTime: "10:30 AM", currentWait: 15, history: [10, 20, 30, 25, 15, 10] },
    dishes: [{ name: "ก๋วยเตี๋ยวไก่ฉีก", price: 60, isSignature: true, image: null }]
  },
  {
    id: 31,
    name: "สว่างบะหมี่ก้ามปู รุ่น3",
    category: "Noodles",
    badges: ["shell_chuan_chim"],
    dietary: [],
    coordinates: [13.7400, 100.5100],
    googleMapsUrl: "https://www.google.com/maps/place/สว่างบะหมี่ก้ามปู",
    sourceUrl: "https://shellshuanshim.com/",
    images: [],
    reviews: { google: 4.5, facebook: 4.6, wongnai: 4.3 },
    influencerReviews: [],
    aiAnalysis: {
      pros: ["Real crab claw", "Third generation recipe", "Rich broth"],
      cons: ["Premium price", "Can sell out"],
      credibilityScore: 88,
      trend: [76, 80, 83, 85, 87, 88]
    },
    queueData: { bestTime: "11:00 AM", currentWait: 25, history: [15, 30, 45, 35, 20, 15] },
    dishes: [
      { name: "บะหมี่ก้ามปู", price: 150, isSignature: true, image: null },
      { name: "เกี๊ยวกุ้ง", price: 80, isSignature: false, image: null }
    ]
  },
  {
    id: 32,
    name: "ขนมเส้นคุณย่า",
    category: "Noodles",
    badges: ["shell_chuan_chim"],
    dietary: [],
    coordinates: [13.7350, 100.5250],
    googleMapsUrl: "https://www.google.com/maps/place/ขนมเส้นคุณย่า",
    sourceUrl: "https://shellshuanshim.com/",
    images: [],
    reviews: { google: 4.3, facebook: 4.4, wongnai: 4.1 },
    influencerReviews: [],
    aiAnalysis: {
      pros: ["Grandma's recipe", "Traditional noodles", "Homemade taste"],
      cons: ["Limited hours", "Small portions"],
      credibilityScore: 82,
      trend: [68, 72, 76, 79, 81, 82]
    },
    queueData: { bestTime: "10:00 AM", currentWait: 10, history: [5, 15, 25, 20, 10, 5] },
    dishes: [{ name: "ขนมเส้นน้ำพริก", price: 70, isSignature: true, image: null }]
  },
  {
    id: 33,
    name: "ราดหน้าโรงเหล็ก",
    category: "Noodles",
    badges: ["shell_chuan_chim"],
    dietary: [],
    coordinates: [13.7450, 100.5050],
    googleMapsUrl: "https://www.google.com/maps/place/ราดหน้าโรงเหล็ก",
    sourceUrl: "https://shellshuanshim.com/",
    images: [],
    reviews: { google: 4.4, facebook: 4.5, wongnai: 4.2 },
    influencerReviews: [],
    aiAnalysis: {
      pros: ["Wok-charred noodles", "Historic location", "Perfect gravy"],
      cons: ["Hot environment", "Wait for wok"],
      credibilityScore: 86,
      trend: [72, 76, 80, 83, 85, 86]
    },
    queueData: { bestTime: "11:30 AM", currentWait: 20, history: [10, 25, 40, 30, 15, 10] },
    dishes: [
      { name: "ราดหน้าหมู", price: 70, isSignature: true, image: null },
      { name: "ราดหน้าทะเล", price: 100, isSignature: false, image: null }
    ]
  },
  {
    id: 34,
    name: "เนื้อตุ๋นนางเลิ้ง",
    category: "Noodles",
    badges: ["shell_chuan_chim"],
    dietary: [],
    coordinates: [13.7600, 100.5150],
    googleMapsUrl: "https://www.google.com/maps/place/เนื้อตุ๋นนางเลิ้ง",
    sourceUrl: "https://shellshuanshim.com/",
    images: [],
    reviews: { google: 4.5, facebook: 4.6, wongnai: 4.3 },
    influencerReviews: [],
    aiAnalysis: {
      pros: ["Tender stewed beef", "Nang Leng heritage", "Rich broth"],
      cons: ["Old area", "Limited seating"],
      credibilityScore: 88,
      trend: [76, 80, 83, 85, 87, 88]
    },
    queueData: { bestTime: "11:00 AM", currentWait: 15, history: [10, 20, 35, 25, 15, 10] },
    dishes: [
      { name: "เนื้อตุ๋น", price: 100, isSignature: true, image: null },
      { name: "ก๋วยเตี๋ยวเนื้อ", price: 80, isSignature: false, image: null }
    ]
  },
  // ========== เชลล์ชวนชิม 2025 - หมวดอาหารไทยใต้/อื่นๆ ==========
  {
    id: 35,
    name: "แม่จี๊ดห่อหมกปลาทะเล-ข้าวแกงใต้",
    category: "Southern Thai",
    badges: ["shell_chuan_chim"],
    dietary: [],
    coordinates: [13.7300, 100.5300],
    googleMapsUrl: "https://www.google.com/maps/place/แม่จี๊ดห่อหมกปลาทะเล",
    sourceUrl: "https://shellshuanshim.com/",
    images: [],
    reviews: { google: 4.4, facebook: 4.5, wongnai: 4.2 },
    influencerReviews: [],
    aiAnalysis: {
      pros: ["Authentic Southern Thai", "Fresh seafood", "Spicy and flavorful"],
      cons: ["Very spicy", "Limited parking"],
      credibilityScore: 86,
      trend: [72, 76, 80, 83, 85, 86]
    },
    queueData: { bestTime: "11:30 AM", currentWait: 20, history: [10, 25, 40, 30, 15, 10] },
    dishes: [
      { name: "ห่อหมกปลาทะเล", price: 120, isSignature: true, image: null },
      { name: "ข้าวแกงใต้", price: 80, isSignature: false, image: null }
    ]
  },
  {
    id: 36,
    name: "บ้านประภา",
    category: "Southern Thai",
    badges: ["shell_chuan_chim"],
    dietary: [],
    coordinates: [13.7800, 100.5700],
    googleMapsUrl: "https://www.google.com/maps/place/บ้านประภา",
    sourceUrl: "https://shellshuanshim.com/",
    images: [],
    reviews: { google: 4.5, facebook: 4.6, wongnai: 4.3 },
    influencerReviews: [],
    aiAnalysis: {
      pros: ["50+ years old", "Traditional Southern recipe", "Family-run"],
      cons: ["Far from center", "Old house setting"],
      credibilityScore: 88,
      trend: [76, 80, 83, 85, 87, 88]
    },
    queueData: { bestTime: "12:00 PM", currentWait: 15, history: [10, 20, 30, 25, 15, 10] },
    dishes: [
      { name: "แกงส้ม", price: 100, isSignature: true, image: null },
      { name: "ไข่ตุ๋น", price: 80, isSignature: false, image: null }
    ]
  },
  {
    id: 37,
    name: "ข้าวกะหรี่-สตูนางเลิ้ง",
    category: "Thai",
    badges: ["shell_chuan_chim"],
    dietary: [],
    coordinates: [13.7620, 100.5180],
    googleMapsUrl: "https://www.google.com/maps/place/ข้าวกะหรี่สตูนางเลิ้ง",
    sourceUrl: "https://shellshuanshim.com/",
    images: [],
    reviews: { google: 4.3, facebook: 4.4, wongnai: 4.1 },
    influencerReviews: [],
    aiAnalysis: {
      pros: ["Traditional curry recipe", "Nang Leng heritage", "Rich flavors"],
      cons: ["Limited menu", "Old area"],
      credibilityScore: 84,
      trend: [70, 74, 78, 81, 83, 84]
    },
    queueData: { bestTime: "11:00 AM", currentWait: 10, history: [5, 15, 25, 20, 10, 5] },
    dishes: [
      { name: "ข้าวกะหรี่", price: 80, isSignature: true, image: null },
      { name: "สตู", price: 90, isSignature: false, image: null }
    ]
  },
  // ========== เชลล์ชวนชิม 2025 - หมวดอาหารจีน (เพิ่มเติม) ==========
  {
    id: 38,
    name: "เล่งหงษ์ ซาลาเปา",
    category: "Chinese",
    badges: ["shell_chuan_chim"],
    dietary: [],
    coordinates: [13.7320, 100.5220],
    googleMapsUrl: "https://www.google.com/maps/place/เล่งหงษ์+ซาลาเปา",
    sourceUrl: "https://shellshuanshim.com/",
    images: [],
    reviews: { google: 4.4, facebook: 4.5, wongnai: 4.2 },
    influencerReviews: [],
    aiAnalysis: {
      pros: ["Famous bao buns", "Fluffy texture", "Various fillings"],
      cons: ["Long queue", "Can sell out"],
      credibilityScore: 86,
      trend: [72, 76, 80, 83, 85, 86]
    },
    queueData: { bestTime: "10:00 AM", currentWait: 20, history: [10, 25, 40, 30, 15, 10] },
    dishes: [
      { name: "ซาลาเปาไส้หมูแดง", price: 25, isSignature: true, image: null },
      { name: "ซาลาเปาครีม", price: 20, isSignature: false, image: null }
    ]
  },
  {
    id: 39,
    name: "ห้องอาหารจีน ซุยเซียน",
    category: "Chinese",
    badges: ["shell_chuan_chim"],
    dietary: [],
    coordinates: [13.7410, 100.5280],
    googleMapsUrl: "https://www.google.com/maps/place/ห้องอาหารจีน+ซุยเซียน",
    sourceUrl: "https://shellshuanshim.com/",
    images: [],
    reviews: { google: 4.3, facebook: 4.4, wongnai: 4.1 },
    influencerReviews: [],
    aiAnalysis: {
      pros: ["Classic Cantonese", "Elegant dining", "Dim sum available"],
      cons: ["Higher price", "Reservation needed"],
      credibilityScore: 84,
      trend: [70, 74, 78, 81, 83, 84]
    },
    queueData: { bestTime: "11:30 AM", currentWait: 10, history: [5, 15, 25, 20, 10, 5] },
    dishes: [{ name: "Dim Sum Set", price: 300, isSignature: true, image: null }]
  },
  {
    id: 40,
    name: "พรทิภาฮ่อยจ๊อ",
    category: "Chinese",
    badges: ["shell_chuan_chim"],
    dietary: [],
    coordinates: [13.7290, 100.5170],
    googleMapsUrl: "https://www.google.com/maps/place/พรทิภาฮ่อยจ๊อ",
    sourceUrl: "https://shellshuanshim.com/",
    images: [],
    reviews: { google: 4.4, facebook: 4.5, wongnai: 4.2 },
    influencerReviews: [],
    aiAnalysis: {
      pros: ["Famous hoy jor", "Crispy shell", "Fresh filling"],
      cons: ["Deep fried", "Limited variety"],
      credibilityScore: 85,
      trend: [71, 75, 79, 82, 84, 85]
    },
    queueData: { bestTime: "3:00 PM", currentWait: 10, history: [5, 15, 25, 20, 10, 5] },
    dishes: [{ name: "ฮ่อยจ๊อ", price: 80, isSignature: true, image: null }]
  },
  {
    id: 41,
    name: "จิ๊บกี่",
    category: "Chinese",
    badges: ["shell_chuan_chim"],
    dietary: [],
    coordinates: [13.7270, 100.5150],
    googleMapsUrl: "https://www.google.com/maps/place/จิ๊บกี่",
    sourceUrl: "https://shellshuanshim.com/",
    images: [],
    reviews: { google: 4.3, facebook: 4.4, wongnai: 4.1 },
    influencerReviews: [],
    aiAnalysis: {
      pros: ["Authentic Chinese", "Old Bangkok location", "Traditional recipes"],
      cons: ["Chinatown parking", "Basic decor"],
      credibilityScore: 83,
      trend: [69, 73, 77, 80, 82, 83]
    },
    queueData: { bestTime: "6:00 PM", currentWait: 15, history: [10, 20, 30, 25, 15, 10] },
    dishes: [{ name: "Chinese Noodles", price: 80, isSignature: true, image: null }]
  },
  {
    id: 42,
    name: "น่ำเทียน by Khanta",
    category: "Chinese",
    badges: ["shell_chuan_chim"],
    dietary: [],
    coordinates: [13.7080, 100.6010],
    googleMapsUrl: "https://www.google.com/maps/place/น่ำเทียน+by+Khanta",
    sourceUrl: "https://shellshuanshim.com/",
    images: [],
    reviews: { google: 4.5, facebook: 4.6, wongnai: 4.3 },
    influencerReviews: [],
    aiAnalysis: {
      pros: ["80+ years history", "Near On Nut", "Classic Chinese dishes"],
      cons: ["Can be busy", "Street parking"],
      credibilityScore: 88,
      trend: [76, 80, 83, 85, 87, 88]
    },
    queueData: { bestTime: "6:30 PM", currentWait: 20, history: [10, 25, 40, 30, 15, 10] },
    dishes: [
      { name: "ข้าวหมูแดง", price: 80, isSignature: true, image: null },
      { name: "เป็ดพะโล้", price: 120, isSignature: false, image: null }
    ]
  },
  {
    id: 43,
    name: "เซี๊ยะไชน่าทาวน์",
    category: "Chinese",
    badges: ["shell_chuan_chim"],
    dietary: [],
    coordinates: [13.7380, 100.5080],
    googleMapsUrl: "https://www.google.com/maps/place/เซี๊ยะไชน่าทาวน์",
    sourceUrl: "https://shellshuanshim.com/",
    images: [],
    reviews: { google: 4.2, facebook: 4.3, wongnai: 4.0 },
    influencerReviews: [],
    aiAnalysis: {
      pros: ["Yaowarat location", "Night market vibes", "Variety of dishes"],
      cons: ["Crowded", "Noisy environment"],
      credibilityScore: 82,
      trend: [68, 72, 76, 79, 81, 82]
    },
    queueData: { bestTime: "7:00 PM", currentWait: 25, history: [15, 30, 45, 35, 20, 15] },
    dishes: [{ name: "Stir-fry Noodles", price: 100, isSignature: true, image: null }]
  },
  // ========== เชลล์ชวนชิม 2025 - หมวดทะเล/อื่นๆ ==========
  {
    id: 44,
    name: "Ranee บางนา",
    category: "International",
    badges: ["shell_chuan_chim"],
    dietary: [],
    coordinates: [13.6540, 100.6020],
    googleMapsUrl: "https://www.google.com/maps/place/Ranee+บางนา",
    sourceUrl: "https://shellshuanshim.com/",
    images: [],
    reviews: { google: 4.4, facebook: 4.5, wongnai: 4.2 },
    influencerReviews: [],
    aiAnalysis: {
      pros: ["Bang Na location", "International menu", "Modern setting"],
      cons: ["Mall parking fee", "Can be busy"],
      credibilityScore: 84,
      trend: [70, 74, 78, 81, 83, 84]
    },
    queueData: { bestTime: "12:00 PM", currentWait: 15, history: [10, 20, 30, 25, 15, 10] },
    dishes: [{ name: "Seafood Platter", price: 500, isSignature: true, image: null }]
  },
  {
    id: 45,
    name: "บะหมี่ก้วง",
    category: "Noodles",
    badges: ["shell_chuan_chim"],
    dietary: [],
    coordinates: [13.7430, 100.5120],
    googleMapsUrl: "https://www.google.com/maps/place/บะหมี่ก้วง",
    sourceUrl: "https://shellshuanshim.com/",
    images: [],
    reviews: { google: 4.3, facebook: 4.4, wongnai: 4.1 },
    influencerReviews: [],
    aiAnalysis: {
      pros: ["Traditional noodles", "Old Bangkok", "Affordable"],
      cons: ["Small shop", "Limited seating"],
      credibilityScore: 82,
      trend: [68, 72, 76, 79, 81, 82]
    },
    queueData: { bestTime: "11:00 AM", currentWait: 10, history: [5, 15, 25, 20, 10, 5] },
    dishes: [{ name: "บะหมี่แห้ง", price: 60, isSignature: true, image: null }]
  },
  // ========== เชลล์ชวนชิม 2025 - หมวดทะเล ==========
  {
    id: 46,
    name: "ร้านอาหารทะเลบางบัวทอง",
    category: "Seafood",
    badges: ["shell_chuan_chim"],
    dietary: [],
    coordinates: [13.8900, 100.4100],
    googleMapsUrl: "https://www.google.com/maps/place/ร้านอาหารทะเลบางบัวทอง",
    sourceUrl: "https://shellshuanshim.com/",
    images: [],
    reviews: { google: 4.4, facebook: 4.5, wongnai: 4.2 },
    influencerReviews: [],
    aiAnalysis: {
      pros: ["Fresh seafood", "Large portions", "Reasonable prices"],
      cons: ["Far from center", "Crowded weekends"],
      credibilityScore: 85,
      trend: [71, 75, 79, 82, 84, 85]
    },
    queueData: { bestTime: "5:00 PM", currentWait: 30, history: [15, 30, 50, 45, 25, 15] },
    dishes: [
      { name: "ปูเผา", price: 600, isSignature: true, image: null },
      { name: "กุ้งอบวุ้นเส้น", price: 350, isSignature: false, image: null }
    ]
  },
  {
    id: 47,
    name: "ศรีนครซีฟู้ด",
    category: "Seafood",
    badges: ["shell_chuan_chim"],
    dietary: [],
    coordinates: [13.8200, 100.4500],
    googleMapsUrl: "https://www.google.com/maps/place/ศรีนครซีฟู้ด",
    sourceUrl: "https://shellshuanshim.com/",
    images: [],
    reviews: { google: 4.5, facebook: 4.6, wongnai: 4.3 },
    influencerReviews: [],
    aiAnalysis: {
      pros: ["River view", "Fresh catch daily", "Famous location"],
      cons: ["Pricey", "Hard to park"],
      credibilityScore: 88,
      trend: [76, 80, 83, 85, 87, 88]
    },
    queueData: { bestTime: "6:00 PM", currentWait: 45, history: [20, 40, 60, 55, 35, 20] },
    dishes: [
      { name: "ปูไข่เผา", price: 800, isSignature: true, image: null },
      { name: "ปลากะพงนึ่งมะนาว", price: 400, isSignature: false, image: null }
    ]
  },
  // ========== เชลล์ชวนชิม 2025 - หมวดอีสาน ==========
  {
    id: 48,
    name: "ส้มตำมะนาวศรี",
    category: "Isaan",
    badges: ["shell_chuan_chim"],
    dietary: [],
    coordinates: [13.7500, 100.5300],
    googleMapsUrl: "https://www.google.com/maps/place/ส้มตำมะนาวศรี",
    sourceUrl: "https://shellshuanshim.com/",
    images: [],
    reviews: { google: 4.3, facebook: 4.4, wongnai: 4.1 },
    influencerReviews: [],
    aiAnalysis: {
      pros: ["Authentic Isaan", "Spicy papaya salad", "Late night"],
      cons: ["Very spicy", "Street side"],
      credibilityScore: 84,
      trend: [70, 74, 78, 81, 83, 84]
    },
    queueData: { bestTime: "7:00 PM", currentWait: 15, history: [10, 20, 30, 25, 15, 10] },
    dishes: [
      { name: "ส้มตำไทย", price: 60, isSignature: true, image: null },
      { name: "ไก่ย่าง", price: 120, isSignature: false, image: null }
    ]
  },
  {
    id: 49,
    name: "แพย่าเฮีย",
    category: "Isaan",
    badges: ["shell_chuan_chim"],
    dietary: [],
    coordinates: [13.7400, 100.5200],
    googleMapsUrl: "https://www.google.com/maps/place/แพย่าเฮีย",
    sourceUrl: "https://shellshuanshim.com/",
    images: [],
    reviews: { google: 4.4, facebook: 4.5, wongnai: 4.2 },
    influencerReviews: [],
    aiAnalysis: {
      pros: ["Original recipe", "Riverside", "Traditional Isaan"],
      cons: ["Mosquitoes", "Basic facilities"],
      credibilityScore: 86,
      trend: [72, 76, 80, 83, 85, 86]
    },
    queueData: { bestTime: "6:00 PM", currentWait: 20, history: [10, 25, 40, 30, 15, 10] },
    dishes: [
      { name: "ลาบหมู", price: 80, isSignature: true, image: null },
      { name: "ต้มแซ่บกระดูก", price: 150, isSignature: false, image: null }
    ]
  },
  // ========== เชลล์ชวนชิม 2025 - หมวดเหนือ ==========
  {
    id: 50,
    name: "ข้าวซอยนิมมาน",
    category: "Northern Thai",
    badges: ["shell_chuan_chim"],
    dietary: [],
    coordinates: [18.7900, 98.9700],
    googleMapsUrl: "https://www.google.com/maps/place/ข้าวซอยนิมมาน",
    sourceUrl: "https://shellshuanshim.com/",
    images: [],
    reviews: { google: 4.5, facebook: 4.6, wongnai: 4.3 },
    influencerReviews: [],
    aiAnalysis: {
      pros: ["Authentic Khao Soi", "Chiang Mai heritage", "Rich curry"],
      cons: ["In Chiang Mai", "Tourist area"],
      credibilityScore: 90,
      trend: [80, 84, 87, 89, 90, 90]
    },
    queueData: { bestTime: "11:30 AM", currentWait: 25, history: [15, 30, 45, 35, 20, 15] },
    dishes: [
      { name: "ข้าวซอยไก่", price: 80, isSignature: true, image: null },
      { name: "ข้าวซอยเนื้อ", price: 100, isSignature: false, image: null }
    ]
  },
  {
    id: 51,
    name: "แฮงเลยเจ้าเก่า",
    category: "Northern Thai",
    badges: ["shell_chuan_chim"],
    dietary: [],
    coordinates: [18.7800, 98.9800],
    googleMapsUrl: "https://www.google.com/maps/place/แฮงเลยเจ้าเก่า",
    sourceUrl: "https://shellshuanshim.com/",
    images: [],
    reviews: { google: 4.4, facebook: 4.5, wongnai: 4.2 },
    influencerReviews: [],
    aiAnalysis: {
      pros: ["Traditional Hang Lay", "Northern spices", "Authentic recipe"],
      cons: ["In Chiang Mai", "Limited seating"],
      credibilityScore: 88,
      trend: [76, 80, 83, 85, 87, 88]
    },
    queueData: { bestTime: "12:00 PM", currentWait: 15, history: [10, 20, 30, 25, 15, 10] },
    dishes: [
      { name: "แกงแฮงเลย", price: 120, isSignature: true, image: null },
      { name: "น้ำพริกหนุ่ม", price: 80, isSignature: false, image: null }
    ]
  },
  // ========== เชลล์ชวนชิม 2025 - เพิ่มเติม ==========
  {
    id: 52,
    name: "ข้าวขาหมูเจ๊เฉียว",
    category: "Thai",
    badges: ["shell_chuan_chim"],
    dietary: [],
    coordinates: [13.7520, 100.4980],
    googleMapsUrl: "https://www.google.com/maps/place/ข้าวขาหมูเจ๊เฉียว",
    sourceUrl: "https://shellshuanshim.com/",
    images: [],
    reviews: { google: 4.4, facebook: 4.5, wongnai: 4.2 },
    influencerReviews: [],
    aiAnalysis: {
      pros: ["Tender pork leg", "Rich broth", "Old Bangkok"],
      cons: ["Queue at lunch", "Limited parking"],
      credibilityScore: 86,
      trend: [72, 76, 80, 83, 85, 86]
    },
    queueData: { bestTime: "11:00 AM", currentWait: 20, history: [10, 25, 40, 30, 15, 10] },
    dishes: [
      { name: "ข้าวขาหมู", price: 80, isSignature: true, image: null },
      { name: "เครื่องใน", price: 60, isSignature: false, image: null }
    ]
  },
  {
    id: 53,
    name: "หมูฝอยทะเลสาบ",
    category: "Thai",
    badges: ["shell_chuan_chim"],
    dietary: [],
    coordinates: [13.7600, 100.4800],
    googleMapsUrl: "https://www.google.com/maps/place/หมูฝอยทะเลสาบ",
    sourceUrl: "https://shellshuanshim.com/",
    images: [],
    reviews: { google: 4.3, facebook: 4.4, wongnai: 4.1 },
    influencerReviews: [],
    aiAnalysis: {
      pros: ["Famous shredded pork", "Crispy texture", "Riverside"],
      cons: ["Old shop", "Basic setting"],
      credibilityScore: 84,
      trend: [70, 74, 78, 81, 83, 84]
    },
    queueData: { bestTime: "10:00 AM", currentWait: 10, history: [5, 15, 25, 20, 10, 5] },
    dishes: [
      { name: "หมูฝอย", price: 100, isSignature: true, image: null },
      { name: "ข้าวหมูแดง", price: 60, isSignature: false, image: null }
    ]
  },
  {
    id: 54,
    name: "ผัดไทยทิพย์ประตูนาง",
    category: "Pad Thai",
    badges: ["shell_chuan_chim"],
    dietary: [],
    coordinates: [13.7480, 100.4950],
    googleMapsUrl: "https://www.google.com/maps/place/ผัดไทยทิพย์ประตูนาง",
    sourceUrl: "https://shellshuanshim.com/",
    images: [],
    reviews: { google: 4.3, facebook: 4.4, wongnai: 4.1 },
    influencerReviews: [],
    aiAnalysis: {
      pros: ["Wok-charred pad thai", "Old Bangkok", "Street food vibes"],
      cons: ["Street seating", "Hot weather"],
      credibilityScore: 85,
      trend: [71, 75, 79, 82, 84, 85]
    },
    queueData: { bestTime: "7:00 PM", currentWait: 25, history: [15, 30, 45, 35, 20, 15] },
    dishes: [
      { name: "ผัดไทยกุ้งสด", price: 80, isSignature: true, image: null },
      { name: "ผัดไทยห่อไข่", price: 90, isSignature: false, image: null }
    ]
  },
  {
    id: 55,
    name: "ก๋วยจั๊บนายเอี้ยง",
    category: "Noodles",
    badges: ["shell_chuan_chim"],
    dietary: [],
    coordinates: [13.7420, 100.5030],
    googleMapsUrl: "https://www.google.com/maps/place/ก๋วยจั๊บนายเอี้ยง",
    sourceUrl: "https://shellshuanshim.com/",
    images: [],
    reviews: { google: 4.4, facebook: 4.5, wongnai: 4.2 },
    influencerReviews: [],
    aiAnalysis: {
      pros: ["Roll noodle soup", "Pepper broth", "Chinatown legend"],
      cons: ["Late night only", "Crowded"],
      credibilityScore: 88,
      trend: [76, 80, 83, 85, 87, 88]
    },
    queueData: { bestTime: "11:00 PM", currentWait: 20, history: [10, 25, 40, 30, 15, 10] },
    dishes: [
      { name: "ก๋วยจั๊บ", price: 70, isSignature: true, image: null },
      { name: "เครื่องใน", price: 60, isSignature: false, image: null }
    ]
  },
  // ========== เชลล์ชวนชิม 2025 - ร้านเพิ่มเติม ==========
  {
    id: 56,
    name: "เจ๊เล็ก ผัดกะเพราหมูกรอบ",
    category: "Thai",
    badges: ["shell_chuan_chim"],
    dietary: [],
    coordinates: [13.7350, 100.5180],
    googleMapsUrl: "https://www.google.com/maps/place/เจ๊เล็ก+ผัดกะเพราหมูกรอบ",
    sourceUrl: "https://shellshuanshim.com/",
    images: [],
    reviews: { google: 4.3, facebook: 4.4, wongnai: 4.1 },
    influencerReviews: [],
    aiAnalysis: {
      pros: ["Crispy pork krapao", "Generous portions", "Spicy"],
      cons: ["Street side", "Hot"],
      credibilityScore: 84,
      trend: [70, 74, 78, 81, 83, 84]
    },
    queueData: { bestTime: "11:30 AM", currentWait: 15, history: [10, 20, 30, 25, 15, 10] },
    dishes: [{ name: "กะเพราหมูกรอบ", price: 80, isSignature: true, image: null }]
  },
  {
    id: 57,
    name: "ข้าวมันไก่ป้ากุ่ม",
    category: "Thai",
    badges: ["shell_chuan_chim"],
    dietary: [],
    coordinates: [13.7450, 100.5220],
    googleMapsUrl: "https://www.google.com/maps/place/ข้าวมันไก่ป้ากุ่ม",
    sourceUrl: "https://shellshuanshim.com/",
    images: [],
    reviews: { google: 4.4, facebook: 4.5, wongnai: 4.2 },
    influencerReviews: [],
    aiAnalysis: {
      pros: ["Moist chicken", "Flavorful rice", "Classic recipe"],
      cons: ["Long queue", "Sells out early"],
      credibilityScore: 86,
      trend: [72, 76, 80, 83, 85, 86]
    },
    queueData: { bestTime: "10:00 AM", currentWait: 20, history: [10, 25, 40, 30, 15, 10] },
    dishes: [
      { name: "ข้าวมันไก่", price: 60, isSignature: true, image: null },
      { name: "ไก่ทอด", price: 70, isSignature: false, image: null }
    ]
  },
  {
    id: 58,
    name: "บะหมี่เป็ดสะพานเหลือง",
    category: "Noodles",
    badges: ["shell_chuan_chim"],
    dietary: [],
    coordinates: [13.7480, 100.5100],
    googleMapsUrl: "https://www.google.com/maps/place/บะหมี่เป็ดสะพานเหลือง",
    sourceUrl: "https://shellshuanshim.com/",
    images: [],
    reviews: { google: 4.3, facebook: 4.4, wongnai: 4.1 },
    influencerReviews: [],
    aiAnalysis: {
      pros: ["Duck noodles", "Rich broth", "Old recipe"],
      cons: ["Hot shop", "Limited parking"],
      credibilityScore: 84,
      trend: [70, 74, 78, 81, 83, 84]
    },
    queueData: { bestTime: "11:00 AM", currentWait: 15, history: [10, 20, 30, 25, 15, 10] },
    dishes: [
      { name: "บะหมี่เป็ด", price: 70, isSignature: true, image: null },
      { name: "เป็ดพะโล้", price: 80, isSignature: false, image: null }
    ]
  },
  {
    id: 59,
    name: "แกงเขียวหวานไก่ย่าง",
    category: "Thai",
    badges: ["shell_chuan_chim"],
    dietary: [],
    coordinates: [13.7520, 100.5150],
    googleMapsUrl: "https://www.google.com/maps/place/แกงเขียวหวานไก่ย่าง",
    sourceUrl: "https://shellshuanshim.com/",
    images: [],
    reviews: { google: 4.4, facebook: 4.5, wongnai: 4.2 },
    influencerReviews: [],
    aiAnalysis: {
      pros: ["Rich green curry", "Grilled chicken", "Coconut milk"],
      cons: ["Spicy", "Crowded"],
      credibilityScore: 85,
      trend: [71, 75, 79, 82, 84, 85]
    },
    queueData: { bestTime: "12:00 PM", currentWait: 15, history: [10, 20, 30, 25, 15, 10] },
    dishes: [
      { name: "แกงเขียวหวาน", price: 100, isSignature: true, image: null },
      { name: "ไก่ย่าง", price: 120, isSignature: false, image: null }
    ]
  },
  {
    id: 60,
    name: "หอยทอดท้าวสมชาย",
    category: "Thai",
    badges: ["shell_chuan_chim"],
    dietary: [],
    coordinates: [13.7550, 100.5080],
    googleMapsUrl: "https://www.google.com/maps/place/หอยทอดท้าวสมชาย",
    sourceUrl: "https://shellshuanshim.com/",
    images: [],
    reviews: { google: 4.3, facebook: 4.4, wongnai: 4.1 },
    influencerReviews: [],
    aiAnalysis: {
      pros: ["Crispy oyster omelette", "Fresh oysters", "Street food"],
      cons: ["Hot", "Limited seating"],
      credibilityScore: 84,
      trend: [70, 74, 78, 81, 83, 84]
    },
    queueData: { bestTime: "7:00 PM", currentWait: 20, history: [10, 25, 40, 30, 15, 10] },
    dishes: [{ name: "หอยทอด", price: 100, isSignature: true, image: null }]
  },
  {
    id: 61,
    name: "ส้มตำป้าเย็น",
    category: "Isaan",
    badges: ["shell_chuan_chim"],
    dietary: [],
    coordinates: [13.7380, 100.5250],
    googleMapsUrl: "https://www.google.com/maps/place/ส้มตำป้าเย็น",
    sourceUrl: "https://shellshuanshim.com/",
    images: [],
    reviews: { google: 4.4, facebook: 4.5, wongnai: 4.2 },
    influencerReviews: [],
    aiAnalysis: {
      pros: ["Authentic papaya salad", "Fresh ingredients", "Many varieties"],
      cons: ["Spicy", "Street side"],
      credibilityScore: 85,
      trend: [71, 75, 79, 82, 84, 85]
    },
    queueData: { bestTime: "6:00 PM", currentWait: 15, history: [10, 20, 30, 25, 15, 10] },
    dishes: [
      { name: "ส้มตำไทย", price: 50, isSignature: true, image: null },
      { name: "ส้มตำปู", price: 80, isSignature: false, image: null }
    ]
  },
  {
    id: 62,
    name: "ข้าวไข่เจียวปู",
    category: "Thai",
    badges: ["shell_chuan_chim"],
    dietary: [],
    coordinates: [13.7400, 100.5300],
    googleMapsUrl: "https://www.google.com/maps/place/ข้าวไข่เจียวปู",
    sourceUrl: "https://shellshuanshim.com/",
    images: [],
    reviews: { google: 4.3, facebook: 4.4, wongnai: 4.1 },
    influencerReviews: [],
    aiAnalysis: {
      pros: ["Crab omelette", "Fluffy eggs", "Generous crab"],
      cons: ["Pricey for street food", "Queue"],
      credibilityScore: 86,
      trend: [72, 76, 80, 83, 85, 86]
    },
    queueData: { bestTime: "11:30 AM", currentWait: 20, history: [10, 25, 40, 30, 15, 10] },
    dishes: [
      { name: "ไข่เจียวปู", price: 150, isSignature: true, image: null },
      { name: "ไข่เจียวหมูสับ", price: 60, isSignature: false, image: null }
    ]
  },
  {
    id: 63,
    name: "ก๋วยเตี๋ยวหมูตุ๋นพระราม 4",
    category: "Noodles",
    badges: ["shell_chuan_chim"],
    dietary: [],
    coordinates: [13.7200, 100.5300],
    googleMapsUrl: "https://www.google.com/maps/place/ก๋วยเตี๋ยวหมูตุ๋นพระราม+4",
    sourceUrl: "https://shellshuanshim.com/",
    images: [],
    reviews: { google: 4.4, facebook: 4.5, wongnai: 4.2 },
    influencerReviews: [],
    aiAnalysis: {
      pros: ["Tender stewed pork", "Rich broth", "Lunch favorite"],
      cons: ["Crowded lunch", "Hard to park"],
      credibilityScore: 85,
      trend: [71, 75, 79, 82, 84, 85]
    },
    queueData: { bestTime: "10:30 AM", currentWait: 15, history: [10, 20, 30, 25, 15, 10] },
    dishes: [
      { name: "ก๋วยเตี๋ยวหมูตุ๋น", price: 70, isSignature: true, image: null },
      { name: "เกี๊ยวทอด", price: 50, isSignature: false, image: null }
    ]
  },
  {
    id: 64,
    name: "ขนมจีนน้ำพริก",
    category: "Thai",
    badges: ["shell_chuan_chim"],
    dietary: [],
    coordinates: [13.7550, 100.5200],
    googleMapsUrl: "https://www.google.com/maps/place/ขนมจีนน้ำพริก",
    sourceUrl: "https://shellshuanshim.com/",
    images: [],
    reviews: { google: 4.3, facebook: 4.4, wongnai: 4.1 },
    influencerReviews: [],
    aiAnalysis: {
      pros: ["Fresh rice noodles", "Variety of curries", "Traditional"],
      cons: ["Limited hours", "Basic setting"],
      credibilityScore: 83,
      trend: [69, 73, 77, 80, 82, 83]
    },
    queueData: { bestTime: "9:00 AM", currentWait: 10, history: [5, 15, 25, 20, 10, 5] },
    dishes: [
      { name: "ขนมจีนน้ำพริก", price: 50, isSignature: true, image: null },
      { name: "ขนมจีนแกงเขียวหวาน", price: 50, isSignature: false, image: null }
    ]
  },
  {
    id: 65,
    name: "ผัดผักรวมมิตร",
    category: "Thai",
    badges: ["shell_chuan_chim"],
    dietary: ["vegetarian"],
    coordinates: [13.7480, 100.5280],
    googleMapsUrl: "https://www.google.com/maps/place/ผัดผักรวมมิตร",
    sourceUrl: "https://shellshuanshim.com/",
    images: [],
    reviews: { google: 4.2, facebook: 4.3, wongnai: 4.0 },
    influencerReviews: [],
    aiAnalysis: {
      pros: ["Healthy options", "Fresh vegetables", "Vegetarian friendly"],
      cons: ["Bland for some", "Simple menu"],
      credibilityScore: 80,
      trend: [66, 70, 74, 77, 79, 80]
    },
    queueData: { bestTime: "11:00 AM", currentWait: 10, history: [5, 15, 25, 20, 10, 5] },
    dishes: [{ name: "ผัดผักรวม", price: 80, isSignature: true, image: null }]
  },
  {
    id: 66,
    name: "ข้าวผัดปูม้า",
    category: "Thai",
    badges: ["shell_chuan_chim"],
    dietary: [],
    coordinates: [13.7420, 100.5150],
    googleMapsUrl: "https://www.google.com/maps/place/ข้าวผัดปูม้า",
    sourceUrl: "https://shellshuanshim.com/",
    images: [],
    reviews: { google: 4.4, facebook: 4.5, wongnai: 4.2 },
    influencerReviews: [],
    aiAnalysis: {
      pros: ["Horseshoe crab fried rice", "Unique dish", "Authentic taste"],
      cons: ["Acquired taste", "Seasonal availability"],
      credibilityScore: 86,
      trend: [72, 76, 80, 83, 85, 86]
    },
    queueData: { bestTime: "7:00 PM", currentWait: 20, history: [10, 25, 40, 30, 15, 10] },
    dishes: [{ name: "ข้าวผัดปูม้า", price: 150, isSignature: true, image: null }]
  },
  {
    id: 67,
    name: "ต้มยำกุ้งน้ำข้น",
    category: "Thai",
    badges: ["shell_chuan_chim"],
    dietary: [],
    coordinates: [13.7500, 100.5350],
    googleMapsUrl: "https://www.google.com/maps/place/ต้มยำกุ้งน้ำข้น",
    sourceUrl: "https://shellshuanshim.com/",
    images: [],
    reviews: { google: 4.4, facebook: 4.5, wongnai: 4.2 },
    influencerReviews: [],
    aiAnalysis: {
      pros: ["Creamy tom yum", "Fresh prawns", "Rich flavor"],
      cons: ["Pricey", "Can be crowded"],
      credibilityScore: 86,
      trend: [72, 76, 80, 83, 85, 86]
    },
    queueData: { bestTime: "7:00 PM", currentWait: 25, history: [15, 30, 45, 35, 20, 15] },
    dishes: [{ name: "ต้มยำกุ้งน้ำข้น", price: 250, isSignature: true, image: null }]
  },
  {
    id: 68,
    name: "ข้าวหมกไก่บ้าน",
    category: "Thai",
    badges: ["shell_chuan_chim"],
    dietary: [],
    coordinates: [13.7450, 100.5400],
    googleMapsUrl: "https://www.google.com/maps/place/ข้าวหมกไก่บ้าน",
    sourceUrl: "https://shellshuanshim.com/",
    images: [],
    reviews: { google: 4.3, facebook: 4.4, wongnai: 4.1 },
    influencerReviews: [],
    aiAnalysis: {
      pros: ["Homestyle chicken rice", "Fragrant rice", "Tender chicken"],
      cons: ["Limited variety", "Basic setting"],
      credibilityScore: 84,
      trend: [70, 74, 78, 81, 83, 84]
    },
    queueData: { bestTime: "11:30 AM", currentWait: 10, history: [5, 15, 25, 20, 10, 5] },
    dishes: [
      { name: "ข้าวหมกไก่", price: 70, isSignature: true, image: null },
      { name: "ไก่ทอด", price: 80, isSignature: false, image: null }
    ]
  },
  // ========== เปิบพิสดาร (เพิ่มเติม) ==========
  {
    id: 69,
    name: "ปาท่องโก๋เสวย (เยาวราช)",
    category: "Thai",
    badges: ["perp_pitsadarn"],
    dietary: [],
    coordinates: [13.7390, 100.5110],
    googleMapsUrl: "https://www.google.com/maps/place/ปาท่องโก๋เสวย+เยาวราช",
    sourceUrl: "https://www.facebook.com/PeibPhisdar",
    images: [],
    reviews: { google: 4.5, facebook: 4.6, wongnai: 4.3 },
    influencerReviews: [],
    aiAnalysis: {
      pros: ["Michelin recognized", "Legendary pa thong ko", "Fresh daily"],
      cons: ["Long queue", "Sells out early"],
      credibilityScore: 92,
      trend: [82, 86, 89, 91, 92, 92]
    },
    queueData: { bestTime: "6:00 PM", currentWait: 30, history: [15, 30, 50, 45, 25, 15] },
    dishes: [
      { name: "ปาท่องโก๋ทอด", price: 10, isSignature: true, image: null },
      { name: "ปาท่องโก๋ย่าง", price: 12, isSignature: false, image: null }
    ]
  },
  {
    id: 70,
    name: "กวงข้าวต้ม (เจ้าเก่า)",
    category: "Thai",
    badges: ["perp_pitsadarn"],
    dietary: [],
    coordinates: [13.7410, 100.5030],
    googleMapsUrl: "https://www.google.com/maps/place/กวงข้าวต้ม",
    sourceUrl: "https://www.facebook.com/PeibPhisdar",
    images: [],
    reviews: { google: 4.4, facebook: 4.5, wongnai: 4.2 },
    influencerReviews: [],
    aiAnalysis: {
      pros: ["Traditional rice soup", "Duck polo specialty", "Late night dining"],
      cons: ["Late hours only", "Basic setting"],
      credibilityScore: 86,
      trend: [72, 76, 80, 83, 85, 86]
    },
    queueData: { bestTime: "10:00 PM", currentWait: 15, history: [10, 20, 30, 25, 15, 10] },
    dishes: [
      { name: "เป็ดพะโล้", price: 200, isSignature: true, image: null },
      { name: "หมูทอดน้ำปลา", price: 150, isSignature: false, image: null }
    ]
  },
  {
    id: 71,
    name: "เตี๋ยวเลือกหมูสับปากช่อง",
    category: "Thai",
    badges: ["perp_pitsadarn"],
    dietary: [],
    coordinates: [14.9800, 102.0950],
    googleMapsUrl: "https://www.google.com/maps/place/เตี๋ยวเลือกหมูสับ+ปากช่อง",
    sourceUrl: "https://www.facebook.com/PeibPhisdar",
    images: [],
    reviews: { google: 4.3, facebook: 4.4, wongnai: 4.1 },
    influencerReviews: [],
    aiAnalysis: {
      pros: ["Korat specialty", "Original recipe", "Local favorite"],
      cons: ["In Korat", "Limited hours"],
      credibilityScore: 84,
      trend: [70, 74, 78, 81, 83, 84]
    },
    queueData: { bestTime: "11:00 AM", currentWait: 10, history: [5, 15, 25, 20, 10, 5] },
    dishes: [{ name: "เตี๋ยวเลือกหมูสับ", price: 60, isSignature: true, image: null }]
  },
  {
    id: 72,
    name: "ข้าวขาหมูบางนา",
    category: "Thai",
    badges: ["perp_pitsadarn"],
    dietary: [],
    coordinates: [13.6600, 100.6100],
    googleMapsUrl: "https://www.google.com/maps/place/ข้าวขาหมูบางนา",
    sourceUrl: "https://www.facebook.com/PeibPhisdar",
    images: [],
    reviews: { google: 4.4, facebook: 4.5, wongnai: 4.2 },
    influencerReviews: [],
    aiAnalysis: {
      pros: ["Tender pork leg", "Rich broth", "Bang Na area"],
      cons: ["Mall parking", "Can be busy"],
      credibilityScore: 85,
      trend: [71, 75, 79, 82, 84, 85]
    },
    queueData: { bestTime: "11:30 AM", currentWait: 15, history: [10, 20, 30, 25, 15, 10] },
    dishes: [
      { name: "ข้าวขาหมู", price: 80, isSignature: true, image: null },
      { name: "ขาหมูทอด", price: 100, isSignature: false, image: null }
    ]
  },
  {
    id: 73,
    name: "หมูกรอบบางแค",
    category: "Thai",
    badges: ["perp_pitsadarn"],
    dietary: [],
    coordinates: [13.7100, 100.4200],
    googleMapsUrl: "https://www.google.com/maps/place/หมูกรอบบางแค",
    sourceUrl: "https://www.facebook.com/PeibPhisdar",
    images: [],
    reviews: { google: 4.3, facebook: 4.4, wongnai: 4.1 },
    influencerReviews: [],
    aiAnalysis: {
      pros: ["Crispy pork belly", "Perfect crackling", "Family recipe"],
      cons: ["Far from center", "Weekend crowds"],
      credibilityScore: 83,
      trend: [69, 73, 77, 80, 82, 83]
    },
    queueData: { bestTime: "11:00 AM", currentWait: 10, history: [5, 15, 25, 20, 10, 5] },
    dishes: [{ name: "หมูกรอบ", price: 150, isSignature: true, image: null }]
  }
];

export default RESTAURANTS;
